import React from 'react';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, ListItemButton, Toolbar, Divider, Typography, Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import QueueIcon from '@mui/icons-material/Queue';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import DownloadIcon from '@mui/icons-material/Download';
import SettingsIcon from '@mui/icons-material/Settings';
import RuleIcon from '@mui/icons-material/Rule';
import SwapCallsIcon from '@mui/icons-material/SwapCalls';
import PeopleIcon from '@mui/icons-material/People';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import ComputerIcon from '@mui/icons-material/Computer';
import { useAuth } from '../../hooks/useAuth';

const drawerWidth = 240;

const menuItems = [
  { text: 'Дашборд', icon: <DashboardIcon />, path: '/dashboard', roles: ['super_admin', 'admin', 'operator'] },
  { text: 'Очереди', icon: <QueueIcon />, path: '/queues', roles: ['super_admin', 'admin', 'operator'] },
  { text: 'Талоны', icon: <ConfirmationNumberIcon />, path: '/tickets', roles: ['super_admin', 'admin', 'operator'] },
  { text: 'Операторы', icon: <PersonIcon />, path: '/operators', roles: ['super_admin', 'admin'] },
  { text: 'Кассы', icon: <PersonIcon />, path: '/workstations', roles: ['super_admin', 'admin'] },
  { text: 'Услуги', icon: <BusinessIcon />, path: '/services', roles: ['super_admin', 'admin'] },
  { text: 'Аналитика', icon: <AnalyticsIcon />, path: '/analytics', roles: ['super_admin', 'admin'] },
  { text: 'Заказанные отчёты', icon: <DownloadIcon />, path: '/reports', roles: ['super_admin', 'admin'] },
  { text: 'Пользователи', icon: <PeopleIcon />, path: '/users', roles: ['super_admin', 'admin'] },
  { text: 'Настройки', icon: <SettingsIcon />, path: '/settings', roles: ['super_admin', 'admin'] },
  { text: 'Стратегии очередей', icon: <RuleIcon />, path: '/settings/queues', roles: ['super_admin', 'admin'] },
  { text: 'Шаблоны обслуживания', icon: <SwapCallsIcon />, path: '/settings/queue-patterns', roles: ['super_admin', 'admin'] },
];

const superAdminItems = [
  { text: 'Организации', icon: <SupervisorAccountIcon />, path: '/super-admin/organizations' },
];

export const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isSuperAdmin } = useAuth();

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
        },
      }}
    >
      <Toolbar />
      <List>
        {menuItems
          .filter(item => !user?.role || item.roles.includes(user.role))
          .map((item) => (
            <ListItem key={item.text} disablePadding>
              <ListItemButton
                selected={location.pathname === item.path || location.pathname.startsWith(`${item.path}/`)}
                onClick={() => navigate(item.path)}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          ))}
      </List>
      
      {/* Специальный пункт для операторов */}
      {user?.role === 'operator' && (
        <>
          <Divider />
          <Box sx={{ px: 2, py: 1 }}>
            <Typography variant="overline" color="text.secondary">
              Рабочее место
            </Typography>
          </Box>
          <List>
            <ListItem disablePadding>
              <ListItemButton
                selected={location.pathname === '/operator'}
                onClick={() => navigate('/operator')}
              >
                <ListItemIcon><ComputerIcon /></ListItemIcon>
                <ListItemText primary="Рабочее место оператора" />
              </ListItemButton>
            </ListItem>
          </List>
        </>
      )}
      
      {isSuperAdmin && (
        <>
          <Divider />
          <Box sx={{ px: 2, py: 1 }}>
            <Typography variant="overline" color="text.secondary">
              Супер-администратор
            </Typography>
          </Box>
          <List>
            {superAdminItems.map((item) => (
              <ListItem key={item.text} disablePadding>
                <ListItemButton
                  selected={location.pathname === item.path}
                  onClick={() => navigate(item.path)}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </>
      )}
    </Drawer>
  );
};
